import * as React from "react";

import theme from "@ui/themes/default";

import { Icon, style } from "./Symbolicons";

export const CaretRight = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    style={{ ...style(props.size, props.height), ...props.style }}
    className={props.className}
  >
    <defs>
      <path
        d="M9.49828219,6.89433023 C9.72208653,6.63855384 10.0981733,6.59495399 10.3726482,6.78045699 L10.4390031,6.8316155 L15.7723364,11.4982822 C16.0542056,11.7449178 16.0743392,12.1697043 15.832737,12.44179 L15.7723364,12.5017178 L10.4390031,17.1683845 C10.161912,17.4108392 9.74073689,17.3827609 9.49828219,17.1056698 C9.27447785,16.8498934 9.28118687,16.4713472 9.50148296,16.2239256 L9.56099691,16.1649489 L14.3206667,12 L9.56099691,7.8350511 C9.30522052,7.61124676 9.26162068,7.23515997 9.44712367,6.9606851 L9.49828219,6.89433023 Z"
        id="path-1-caret-right"
      />
    </defs>
    <g
      id="icon-24x24px[16x16px]---line&solid"
      stroke="none"
      strokeWidth={1}
      fill="none"
      fillRule="evenodd"
    >
      <g id="Atom/icon/controls/caret-right/line">
        <mask id="mask-2-caret-right" fill="white">
          <use xlinkHref="#path-1-caret-right" />
        </mask>
        <use
          id="Atom/icon/caret-right"
          fill={props.color || theme.palette.grey600}
          fillRule="nonzero"
          xlinkHref="#path-1-caret-right"
        />
        <g
          id="Group"
          mask="url(#mask-2-caret-right)"
          fill={props.color || theme.palette.grey600}
        >
          <g id="caret-right-color">
            <rect
              id="Rectangle-caret-right"
              x={0}
              y={0}
              width={24}
              height={24}
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);
